export class Info {
    public domain: string = '';
    public company: string = '';
    public yearFounded: string = '';
    public employees: string = '';
    public hq: string = '';
    public annualRevenue: string = '';
    public industry: string = '';
}